(function () {
// Import vendor modules.
// packages/alpinejs/src/scheduler.js
var $4180c5bc1a83c67d$var$flushPending = false;
var $4180c5bc1a83c67d$var$flushing = false;
var $4180c5bc1a83c67d$var$queue = [];
var $4180c5bc1a83c67d$var$lastFlushedIndex = -1;
function $4180c5bc1a83c67d$var$scheduler(callback) {
    $4180c5bc1a83c67d$var$queueJob(callback);
}
function $4180c5bc1a83c67d$var$queueJob(job) {
    if (!$4180c5bc1a83c67d$var$queue.includes(job)) $4180c5bc1a83c67d$var$queue.push(job);
    $4180c5bc1a83c67d$var$queueFlush();
}
function $4180c5bc1a83c67d$var$dequeueJob(job) {
    let index = $4180c5bc1a83c67d$var$queue.indexOf(job);
    if (index !== -1 && index > $4180c5bc1a83c67d$var$lastFlushedIndex) $4180c5bc1a83c67d$var$queue.splice(index, 1);
}
function $4180c5bc1a83c67d$var$queueFlush() {
    if (!$4180c5bc1a83c67d$var$flushing && !$4180c5bc1a83c67d$var$flushPending) {
        $4180c5bc1a83c67d$var$flushPending = true;
        queueMicrotask($4180c5bc1a83c67d$var$flushJobs);
    }
}
function $4180c5bc1a83c67d$var$flushJobs() {
    $4180c5bc1a83c67d$var$flushPending = false;
    $4180c5bc1a83c67d$var$flushing = true;
    for(let i = 0; i < $4180c5bc1a83c67d$var$queue.length; i++){
        $4180c5bc1a83c67d$var$queue[i]();
        $4180c5bc1a83c67d$var$lastFlushedIndex = i;
    }
    $4180c5bc1a83c67d$var$queue.length = 0;
    $4180c5bc1a83c67d$var$lastFlushedIndex = -1;
    $4180c5bc1a83c67d$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $4180c5bc1a83c67d$var$reactive;
var $4180c5bc1a83c67d$var$effect;
var $4180c5bc1a83c67d$var$release;
var $4180c5bc1a83c67d$var$raw;
var $4180c5bc1a83c67d$var$shouldSchedule = true;
function $4180c5bc1a83c67d$var$disableEffectScheduling(callback) {
    $4180c5bc1a83c67d$var$shouldSchedule = false;
    callback();
    $4180c5bc1a83c67d$var$shouldSchedule = true;
}
function $4180c5bc1a83c67d$var$setReactivityEngine(engine) {
    $4180c5bc1a83c67d$var$reactive = engine.reactive;
    $4180c5bc1a83c67d$var$release = engine.release;
    $4180c5bc1a83c67d$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($4180c5bc1a83c67d$var$shouldSchedule) $4180c5bc1a83c67d$var$scheduler(task);
                else task();
            }
        });
    $4180c5bc1a83c67d$var$raw = engine.raw;
}
function $4180c5bc1a83c67d$var$overrideEffect(override) {
    $4180c5bc1a83c67d$var$effect = override;
}
function $4180c5bc1a83c67d$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $4180c5bc1a83c67d$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $4180c5bc1a83c67d$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $4180c5bc1a83c67d$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $4180c5bc1a83c67d$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$4180c5bc1a83c67d$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $4180c5bc1a83c67d$var$onAttributeAddeds = [];
var $4180c5bc1a83c67d$var$onElRemoveds = [];
var $4180c5bc1a83c67d$var$onElAddeds = [];
function $4180c5bc1a83c67d$var$onElAdded(callback) {
    $4180c5bc1a83c67d$var$onElAddeds.push(callback);
}
function $4180c5bc1a83c67d$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $4180c5bc1a83c67d$var$onElRemoveds.push(callback);
    }
}
function $4180c5bc1a83c67d$var$onAttributesAdded(callback) {
    $4180c5bc1a83c67d$var$onAttributeAddeds.push(callback);
}
function $4180c5bc1a83c67d$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $4180c5bc1a83c67d$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $4180c5bc1a83c67d$var$cleanupElement(el) {
    el._x_effects?.forEach($4180c5bc1a83c67d$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $4180c5bc1a83c67d$var$observer = new MutationObserver($4180c5bc1a83c67d$var$onMutate);
var $4180c5bc1a83c67d$var$currentlyObserving = false;
function $4180c5bc1a83c67d$var$startObservingMutations() {
    $4180c5bc1a83c67d$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $4180c5bc1a83c67d$var$currentlyObserving = true;
}
function $4180c5bc1a83c67d$var$stopObservingMutations() {
    $4180c5bc1a83c67d$var$flushObserver();
    $4180c5bc1a83c67d$var$observer.disconnect();
    $4180c5bc1a83c67d$var$currentlyObserving = false;
}
var $4180c5bc1a83c67d$var$queuedMutations = [];
function $4180c5bc1a83c67d$var$flushObserver() {
    let records = $4180c5bc1a83c67d$var$observer.takeRecords();
    $4180c5bc1a83c67d$var$queuedMutations.push(()=>records.length > 0 && $4180c5bc1a83c67d$var$onMutate(records));
    let queueLengthWhenTriggered = $4180c5bc1a83c67d$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($4180c5bc1a83c67d$var$queuedMutations.length === queueLengthWhenTriggered) while($4180c5bc1a83c67d$var$queuedMutations.length > 0)$4180c5bc1a83c67d$var$queuedMutations.shift()();
    });
}
function $4180c5bc1a83c67d$var$mutateDom(callback) {
    if (!$4180c5bc1a83c67d$var$currentlyObserving) return callback();
    $4180c5bc1a83c67d$var$stopObservingMutations();
    let result = callback();
    $4180c5bc1a83c67d$var$startObservingMutations();
    return result;
}
var $4180c5bc1a83c67d$var$isCollecting = false;
var $4180c5bc1a83c67d$var$deferredMutations = [];
function $4180c5bc1a83c67d$var$deferMutations() {
    $4180c5bc1a83c67d$var$isCollecting = true;
}
function $4180c5bc1a83c67d$var$flushAndStopDeferringMutations() {
    $4180c5bc1a83c67d$var$isCollecting = false;
    $4180c5bc1a83c67d$var$onMutate($4180c5bc1a83c67d$var$deferredMutations);
    $4180c5bc1a83c67d$var$deferredMutations = [];
}
function $4180c5bc1a83c67d$var$onMutate(mutations) {
    if ($4180c5bc1a83c67d$var$isCollecting) {
        $4180c5bc1a83c67d$var$deferredMutations = $4180c5bc1a83c67d$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $4180c5bc1a83c67d$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $4180c5bc1a83c67d$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $4180c5bc1a83c67d$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $4180c5bc1a83c67d$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $4180c5bc1a83c67d$var$scope(node) {
    return $4180c5bc1a83c67d$var$mergeProxies($4180c5bc1a83c67d$var$closestDataStack(node));
}
function $4180c5bc1a83c67d$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$4180c5bc1a83c67d$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $4180c5bc1a83c67d$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $4180c5bc1a83c67d$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $4180c5bc1a83c67d$var$closestDataStack(node.parentNode);
}
function $4180c5bc1a83c67d$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $4180c5bc1a83c67d$var$mergeProxyTrap);
}
var $4180c5bc1a83c67d$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $4180c5bc1a83c67d$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $4180c5bc1a83c67d$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $4180c5bc1a83c67d$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $4180c5bc1a83c67d$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$4180c5bc1a83c67d$var$get(data2, path), (value)=>$4180c5bc1a83c67d$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $4180c5bc1a83c67d$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $4180c5bc1a83c67d$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $4180c5bc1a83c67d$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $4180c5bc1a83c67d$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $4180c5bc1a83c67d$var$magics = {};
function $4180c5bc1a83c67d$var$magic(name, callback) {
    $4180c5bc1a83c67d$var$magics[name] = callback;
}
function $4180c5bc1a83c67d$var$injectMagics(obj, el) {
    let memoizedUtilities = $4180c5bc1a83c67d$var$getUtilities(el);
    Object.entries($4180c5bc1a83c67d$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $4180c5bc1a83c67d$var$getUtilities(el) {
    let [utilities, cleanup2] = $4180c5bc1a83c67d$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $4180c5bc1a83c67d$var$interceptor,
        ...utilities
    };
    $4180c5bc1a83c67d$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $4180c5bc1a83c67d$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $4180c5bc1a83c67d$var$handleError(e, el, expression);
    }
}
function $4180c5bc1a83c67d$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $4180c5bc1a83c67d$var$shouldAutoEvaluateFunctions = true;
function $4180c5bc1a83c67d$var$dontAutoEvaluateFunctions(callback) {
    let cache = $4180c5bc1a83c67d$var$shouldAutoEvaluateFunctions;
    $4180c5bc1a83c67d$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $4180c5bc1a83c67d$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $4180c5bc1a83c67d$var$evaluate(el, expression, extras = {}) {
    let result;
    $4180c5bc1a83c67d$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $4180c5bc1a83c67d$var$evaluateLater(...args) {
    return $4180c5bc1a83c67d$var$theEvaluatorFunction(...args);
}
var $4180c5bc1a83c67d$var$theEvaluatorFunction = $4180c5bc1a83c67d$var$normalEvaluator;
function $4180c5bc1a83c67d$var$setEvaluator(newEvaluator) {
    $4180c5bc1a83c67d$var$theEvaluatorFunction = newEvaluator;
}
function $4180c5bc1a83c67d$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $4180c5bc1a83c67d$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$4180c5bc1a83c67d$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $4180c5bc1a83c67d$var$generateEvaluatorFromFunction(dataStack, expression) : $4180c5bc1a83c67d$var$generateEvaluatorFromString(dataStack, expression, el);
    return $4180c5bc1a83c67d$var$tryCatch.bind(null, el, expression, evaluator);
}
function $4180c5bc1a83c67d$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($4180c5bc1a83c67d$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $4180c5bc1a83c67d$var$runIfTypeOfFunction(receiver, result);
    };
}
var $4180c5bc1a83c67d$var$evaluatorMemo = {};
function $4180c5bc1a83c67d$var$generateFunctionFromString(expression, el) {
    if ($4180c5bc1a83c67d$var$evaluatorMemo[expression]) return $4180c5bc1a83c67d$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $4180c5bc1a83c67d$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $4180c5bc1a83c67d$var$evaluatorMemo[expression] = func;
    return func;
}
function $4180c5bc1a83c67d$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $4180c5bc1a83c67d$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $4180c5bc1a83c67d$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$4180c5bc1a83c67d$var$handleError(error2, el, expression));
            if (func.finished) {
                $4180c5bc1a83c67d$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $4180c5bc1a83c67d$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$4180c5bc1a83c67d$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $4180c5bc1a83c67d$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($4180c5bc1a83c67d$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$4180c5bc1a83c67d$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$4180c5bc1a83c67d$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $4180c5bc1a83c67d$var$prefixAsString = "x-";
function $4180c5bc1a83c67d$var$prefix(subject = "") {
    return $4180c5bc1a83c67d$var$prefixAsString + subject;
}
function $4180c5bc1a83c67d$var$setPrefix(newPrefix) {
    $4180c5bc1a83c67d$var$prefixAsString = newPrefix;
}
var $4180c5bc1a83c67d$var$directiveHandlers = {};
function $4180c5bc1a83c67d$var$directive(name, callback) {
    $4180c5bc1a83c67d$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$4180c5bc1a83c67d$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $4180c5bc1a83c67d$var$directiveOrder.indexOf(directive2);
            $4180c5bc1a83c67d$var$directiveOrder.splice(pos >= 0 ? pos : $4180c5bc1a83c67d$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $4180c5bc1a83c67d$var$directiveExists(name) {
    return Object.keys($4180c5bc1a83c67d$var$directiveHandlers).includes(name);
}
function $4180c5bc1a83c67d$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $4180c5bc1a83c67d$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($4180c5bc1a83c67d$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($4180c5bc1a83c67d$var$outNonAlpineAttributes).map($4180c5bc1a83c67d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($4180c5bc1a83c67d$var$byPriority);
    return directives2.map((directive2)=>{
        return $4180c5bc1a83c67d$var$getDirectiveHandler(el, directive2);
    });
}
function $4180c5bc1a83c67d$var$attributesOnly(attributes) {
    return Array.from(attributes).map($4180c5bc1a83c67d$var$toTransformedAttributes()).filter((attr)=>!$4180c5bc1a83c67d$var$outNonAlpineAttributes(attr));
}
var $4180c5bc1a83c67d$var$isDeferringHandlers = false;
var $4180c5bc1a83c67d$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $4180c5bc1a83c67d$var$currentHandlerStackKey = Symbol();
function $4180c5bc1a83c67d$var$deferHandlingDirectives(callback) {
    $4180c5bc1a83c67d$var$isDeferringHandlers = true;
    let key = Symbol();
    $4180c5bc1a83c67d$var$currentHandlerStackKey = key;
    $4180c5bc1a83c67d$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($4180c5bc1a83c67d$var$directiveHandlerStacks.get(key).length)$4180c5bc1a83c67d$var$directiveHandlerStacks.get(key).shift()();
        $4180c5bc1a83c67d$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $4180c5bc1a83c67d$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $4180c5bc1a83c67d$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $4180c5bc1a83c67d$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $4180c5bc1a83c67d$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $4180c5bc1a83c67d$var$evaluateLater.bind($4180c5bc1a83c67d$var$evaluateLater, el),
        evaluate: $4180c5bc1a83c67d$var$evaluate.bind($4180c5bc1a83c67d$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $4180c5bc1a83c67d$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $4180c5bc1a83c67d$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $4180c5bc1a83c67d$var$getElementBoundUtilities(el);
    $4180c5bc1a83c67d$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $4180c5bc1a83c67d$var$isDeferringHandlers ? $4180c5bc1a83c67d$var$directiveHandlerStacks.get($4180c5bc1a83c67d$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $4180c5bc1a83c67d$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $4180c5bc1a83c67d$var$into = (i)=>i;
function $4180c5bc1a83c67d$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $4180c5bc1a83c67d$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $4180c5bc1a83c67d$var$attributeTransformers = [];
function $4180c5bc1a83c67d$var$mapAttributes(callback) {
    $4180c5bc1a83c67d$var$attributeTransformers.push(callback);
}
function $4180c5bc1a83c67d$var$outNonAlpineAttributes({ name: name }) {
    return $4180c5bc1a83c67d$var$alpineAttributeRegex().test(name);
}
var $4180c5bc1a83c67d$var$alpineAttributeRegex = ()=>new RegExp(`^${$4180c5bc1a83c67d$var$prefixAsString}([^:^.]+)\\b`);
function $4180c5bc1a83c67d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($4180c5bc1a83c67d$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $4180c5bc1a83c67d$var$DEFAULT = "DEFAULT";
var $4180c5bc1a83c67d$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $4180c5bc1a83c67d$var$DEFAULT,
    "teleport"
];
function $4180c5bc1a83c67d$var$byPriority(a, b) {
    let typeA = $4180c5bc1a83c67d$var$directiveOrder.indexOf(a.type) === -1 ? $4180c5bc1a83c67d$var$DEFAULT : a.type;
    let typeB = $4180c5bc1a83c67d$var$directiveOrder.indexOf(b.type) === -1 ? $4180c5bc1a83c67d$var$DEFAULT : b.type;
    return $4180c5bc1a83c67d$var$directiveOrder.indexOf(typeA) - $4180c5bc1a83c67d$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $4180c5bc1a83c67d$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $4180c5bc1a83c67d$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$4180c5bc1a83c67d$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $4180c5bc1a83c67d$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $4180c5bc1a83c67d$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $4180c5bc1a83c67d$var$started = false;
function $4180c5bc1a83c67d$var$start() {
    if ($4180c5bc1a83c67d$var$started) $4180c5bc1a83c67d$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $4180c5bc1a83c67d$var$started = true;
    if (!document.body) $4180c5bc1a83c67d$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $4180c5bc1a83c67d$var$dispatch(document, "alpine:init");
    $4180c5bc1a83c67d$var$dispatch(document, "alpine:initializing");
    $4180c5bc1a83c67d$var$startObservingMutations();
    $4180c5bc1a83c67d$var$onElAdded((el)=>$4180c5bc1a83c67d$var$initTree(el, $4180c5bc1a83c67d$var$walk));
    $4180c5bc1a83c67d$var$onElRemoved((el)=>$4180c5bc1a83c67d$var$destroyTree(el));
    $4180c5bc1a83c67d$var$onAttributesAdded((el, attrs)=>{
        $4180c5bc1a83c67d$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$4180c5bc1a83c67d$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($4180c5bc1a83c67d$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $4180c5bc1a83c67d$var$initTree(el);
    });
    $4180c5bc1a83c67d$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $4180c5bc1a83c67d$var$warnAboutMissingPlugins();
    });
}
var $4180c5bc1a83c67d$var$rootSelectorCallbacks = [];
var $4180c5bc1a83c67d$var$initSelectorCallbacks = [];
function $4180c5bc1a83c67d$var$rootSelectors() {
    return $4180c5bc1a83c67d$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $4180c5bc1a83c67d$var$allSelectors() {
    return $4180c5bc1a83c67d$var$rootSelectorCallbacks.concat($4180c5bc1a83c67d$var$initSelectorCallbacks).map((fn)=>fn());
}
function $4180c5bc1a83c67d$var$addRootSelector(selectorCallback) {
    $4180c5bc1a83c67d$var$rootSelectorCallbacks.push(selectorCallback);
}
function $4180c5bc1a83c67d$var$addInitSelector(selectorCallback) {
    $4180c5bc1a83c67d$var$initSelectorCallbacks.push(selectorCallback);
}
function $4180c5bc1a83c67d$var$closestRoot(el, includeInitSelectors = false) {
    return $4180c5bc1a83c67d$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $4180c5bc1a83c67d$var$allSelectors() : $4180c5bc1a83c67d$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $4180c5bc1a83c67d$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $4180c5bc1a83c67d$var$findClosest(el.parentElement, callback);
}
function $4180c5bc1a83c67d$var$isRoot(el) {
    return $4180c5bc1a83c67d$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $4180c5bc1a83c67d$var$initInterceptors2 = [];
function $4180c5bc1a83c67d$var$interceptInit(callback) {
    $4180c5bc1a83c67d$var$initInterceptors2.push(callback);
}
var $4180c5bc1a83c67d$var$markerDispenser = 1;
function $4180c5bc1a83c67d$var$initTree(el, walker = $4180c5bc1a83c67d$var$walk, intercept = ()=>{}) {
    if ($4180c5bc1a83c67d$var$findClosest(el, (i)=>i._x_ignore)) return;
    $4180c5bc1a83c67d$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $4180c5bc1a83c67d$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $4180c5bc1a83c67d$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $4180c5bc1a83c67d$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $4180c5bc1a83c67d$var$destroyTree(root, walker = $4180c5bc1a83c67d$var$walk) {
    walker(root, (el)=>{
        $4180c5bc1a83c67d$var$cleanupElement(el);
        $4180c5bc1a83c67d$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $4180c5bc1a83c67d$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($4180c5bc1a83c67d$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $4180c5bc1a83c67d$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $4180c5bc1a83c67d$var$tickStack = [];
var $4180c5bc1a83c67d$var$isHolding = false;
function $4180c5bc1a83c67d$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $4180c5bc1a83c67d$var$isHolding || setTimeout(()=>{
            $4180c5bc1a83c67d$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $4180c5bc1a83c67d$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $4180c5bc1a83c67d$var$releaseNextTicks() {
    $4180c5bc1a83c67d$var$isHolding = false;
    while($4180c5bc1a83c67d$var$tickStack.length)$4180c5bc1a83c67d$var$tickStack.shift()();
}
function $4180c5bc1a83c67d$var$holdNextTicks() {
    $4180c5bc1a83c67d$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $4180c5bc1a83c67d$var$setClasses(el, value) {
    if (Array.isArray(value)) return $4180c5bc1a83c67d$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $4180c5bc1a83c67d$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $4180c5bc1a83c67d$var$setClasses(el, value());
    return $4180c5bc1a83c67d$var$setClassesFromString(el, value);
}
function $4180c5bc1a83c67d$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $4180c5bc1a83c67d$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $4180c5bc1a83c67d$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $4180c5bc1a83c67d$var$setStylesFromObject(el, value);
    return $4180c5bc1a83c67d$var$setStylesFromString(el, value);
}
function $4180c5bc1a83c67d$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $4180c5bc1a83c67d$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $4180c5bc1a83c67d$var$setStyles(el, previousStyles);
    };
}
function $4180c5bc1a83c67d$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $4180c5bc1a83c67d$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $4180c5bc1a83c67d$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$4180c5bc1a83c67d$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $4180c5bc1a83c67d$var$registerTransitionsFromHelper(el, modifiers, value);
    else $4180c5bc1a83c67d$var$registerTransitionsFromClassString(el, expression, value);
});
function $4180c5bc1a83c67d$var$registerTransitionsFromClassString(el, classString, stage) {
    $4180c5bc1a83c67d$var$registerTransitionObject(el, $4180c5bc1a83c67d$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $4180c5bc1a83c67d$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $4180c5bc1a83c67d$var$registerTransitionObject(el, $4180c5bc1a83c67d$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $4180c5bc1a83c67d$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $4180c5bc1a83c67d$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $4180c5bc1a83c67d$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $4180c5bc1a83c67d$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $4180c5bc1a83c67d$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $4180c5bc1a83c67d$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $4180c5bc1a83c67d$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $4180c5bc1a83c67d$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $4180c5bc1a83c67d$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $4180c5bc1a83c67d$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $4180c5bc1a83c67d$var$closestHide(parent);
}
function $4180c5bc1a83c67d$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $4180c5bc1a83c67d$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $4180c5bc1a83c67d$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $4180c5bc1a83c67d$var$once(()=>{
        $4180c5bc1a83c67d$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $4180c5bc1a83c67d$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $4180c5bc1a83c67d$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $4180c5bc1a83c67d$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $4180c5bc1a83c67d$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $4180c5bc1a83c67d$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $4180c5bc1a83c67d$var$mutateDom(()=>{
                stages.end();
            });
            $4180c5bc1a83c67d$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $4180c5bc1a83c67d$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $4180c5bc1a83c67d$var$isCloning = false;
function $4180c5bc1a83c67d$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$4180c5bc1a83c67d$var$isCloning ? fallback(...args) : callback(...args);
}
function $4180c5bc1a83c67d$var$onlyDuringClone(callback) {
    return (...args)=>$4180c5bc1a83c67d$var$isCloning && callback(...args);
}
var $4180c5bc1a83c67d$var$interceptors = [];
function $4180c5bc1a83c67d$var$interceptClone(callback) {
    $4180c5bc1a83c67d$var$interceptors.push(callback);
}
function $4180c5bc1a83c67d$var$cloneNode(from, to) {
    $4180c5bc1a83c67d$var$interceptors.forEach((i)=>i(from, to));
    $4180c5bc1a83c67d$var$isCloning = true;
    $4180c5bc1a83c67d$var$dontRegisterReactiveSideEffects(()=>{
        $4180c5bc1a83c67d$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $4180c5bc1a83c67d$var$isCloning = false;
}
var $4180c5bc1a83c67d$var$isCloningLegacy = false;
function $4180c5bc1a83c67d$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $4180c5bc1a83c67d$var$isCloning = true;
    $4180c5bc1a83c67d$var$isCloningLegacy = true;
    $4180c5bc1a83c67d$var$dontRegisterReactiveSideEffects(()=>{
        $4180c5bc1a83c67d$var$cloneTree(newEl);
    });
    $4180c5bc1a83c67d$var$isCloning = false;
    $4180c5bc1a83c67d$var$isCloningLegacy = false;
}
function $4180c5bc1a83c67d$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $4180c5bc1a83c67d$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $4180c5bc1a83c67d$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $4180c5bc1a83c67d$var$initTree(el, shallowWalker);
}
function $4180c5bc1a83c67d$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $4180c5bc1a83c67d$var$effect;
    $4180c5bc1a83c67d$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $4180c5bc1a83c67d$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $4180c5bc1a83c67d$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $4180c5bc1a83c67d$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $4180c5bc1a83c67d$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $4180c5bc1a83c67d$var$camelCase(name) : name;
    switch(name){
        case "value":
            $4180c5bc1a83c67d$var$bindInputValue(el, value);
            break;
        case "style":
            $4180c5bc1a83c67d$var$bindStyles(el, value);
            break;
        case "class":
            $4180c5bc1a83c67d$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $4180c5bc1a83c67d$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $4180c5bc1a83c67d$var$bindAttribute(el, name, value);
            break;
    }
}
function $4180c5bc1a83c67d$var$bindInputValue(el, value) {
    if ($4180c5bc1a83c67d$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $4180c5bc1a83c67d$var$safeParseBoolean(el.value) === value;
            else el.checked = $4180c5bc1a83c67d$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($4180c5bc1a83c67d$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$4180c5bc1a83c67d$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $4180c5bc1a83c67d$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $4180c5bc1a83c67d$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $4180c5bc1a83c67d$var$setClasses(el, value);
}
function $4180c5bc1a83c67d$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $4180c5bc1a83c67d$var$setStyles(el, value);
}
function $4180c5bc1a83c67d$var$bindAttributeAndProperty(el, name, value) {
    $4180c5bc1a83c67d$var$bindAttribute(el, name, value);
    $4180c5bc1a83c67d$var$setPropertyIfChanged(el, name, value);
}
function $4180c5bc1a83c67d$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $4180c5bc1a83c67d$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($4180c5bc1a83c67d$var$isBooleanAttr(name)) value = name;
        $4180c5bc1a83c67d$var$setIfChanged(el, name, value);
    }
}
function $4180c5bc1a83c67d$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $4180c5bc1a83c67d$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $4180c5bc1a83c67d$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $4180c5bc1a83c67d$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $4180c5bc1a83c67d$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $4180c5bc1a83c67d$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $4180c5bc1a83c67d$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $4180c5bc1a83c67d$var$isBooleanAttr(attrName) {
    return $4180c5bc1a83c67d$var$booleanAttributes.has(attrName);
}
function $4180c5bc1a83c67d$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $4180c5bc1a83c67d$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $4180c5bc1a83c67d$var$getAttributeBinding(el, name, fallback);
}
function $4180c5bc1a83c67d$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $4180c5bc1a83c67d$var$dontAutoEvaluateFunctions(()=>{
            return $4180c5bc1a83c67d$var$evaluate(el, binding.expression);
        });
    }
    return $4180c5bc1a83c67d$var$getAttributeBinding(el, name, fallback);
}
function $4180c5bc1a83c67d$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($4180c5bc1a83c67d$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $4180c5bc1a83c67d$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $4180c5bc1a83c67d$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $4180c5bc1a83c67d$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $4180c5bc1a83c67d$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $4180c5bc1a83c67d$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $4180c5bc1a83c67d$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($4180c5bc1a83c67d$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($4180c5bc1a83c67d$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($4180c5bc1a83c67d$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $4180c5bc1a83c67d$var$release(reference);
    };
}
function $4180c5bc1a83c67d$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $4180c5bc1a83c67d$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($4180c5bc1a83c67d$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $4180c5bc1a83c67d$var$stores = {};
var $4180c5bc1a83c67d$var$isReactive = false;
function $4180c5bc1a83c67d$var$store(name, value) {
    if (!$4180c5bc1a83c67d$var$isReactive) {
        $4180c5bc1a83c67d$var$stores = $4180c5bc1a83c67d$var$reactive($4180c5bc1a83c67d$var$stores);
        $4180c5bc1a83c67d$var$isReactive = true;
    }
    if (value === void 0) return $4180c5bc1a83c67d$var$stores[name];
    $4180c5bc1a83c67d$var$stores[name] = value;
    $4180c5bc1a83c67d$var$initInterceptors($4180c5bc1a83c67d$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $4180c5bc1a83c67d$var$stores[name].init();
}
function $4180c5bc1a83c67d$var$getStores() {
    return $4180c5bc1a83c67d$var$stores;
}
// packages/alpinejs/src/binds.js
var $4180c5bc1a83c67d$var$binds = {};
function $4180c5bc1a83c67d$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $4180c5bc1a83c67d$var$applyBindingsObject(name, getBindings());
    else $4180c5bc1a83c67d$var$binds[name] = getBindings;
    return ()=>{};
}
function $4180c5bc1a83c67d$var$injectBindingProviders(obj) {
    Object.entries($4180c5bc1a83c67d$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $4180c5bc1a83c67d$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $4180c5bc1a83c67d$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $4180c5bc1a83c67d$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $4180c5bc1a83c67d$var$datas = {};
function $4180c5bc1a83c67d$var$data(name, callback) {
    $4180c5bc1a83c67d$var$datas[name] = callback;
}
function $4180c5bc1a83c67d$var$injectDataProviders(obj, context) {
    Object.entries($4180c5bc1a83c67d$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $4180c5bc1a83c67d$var$Alpine = {
    get reactive () {
        return $4180c5bc1a83c67d$var$reactive;
    },
    get release () {
        return $4180c5bc1a83c67d$var$release;
    },
    get effect () {
        return $4180c5bc1a83c67d$var$effect;
    },
    get raw () {
        return $4180c5bc1a83c67d$var$raw;
    },
    version: "3.14.7",
    flushAndStopDeferringMutations: $4180c5bc1a83c67d$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $4180c5bc1a83c67d$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $4180c5bc1a83c67d$var$disableEffectScheduling,
    startObservingMutations: $4180c5bc1a83c67d$var$startObservingMutations,
    stopObservingMutations: $4180c5bc1a83c67d$var$stopObservingMutations,
    setReactivityEngine: $4180c5bc1a83c67d$var$setReactivityEngine,
    onAttributeRemoved: $4180c5bc1a83c67d$var$onAttributeRemoved,
    onAttributesAdded: $4180c5bc1a83c67d$var$onAttributesAdded,
    closestDataStack: $4180c5bc1a83c67d$var$closestDataStack,
    skipDuringClone: $4180c5bc1a83c67d$var$skipDuringClone,
    onlyDuringClone: $4180c5bc1a83c67d$var$onlyDuringClone,
    addRootSelector: $4180c5bc1a83c67d$var$addRootSelector,
    addInitSelector: $4180c5bc1a83c67d$var$addInitSelector,
    interceptClone: $4180c5bc1a83c67d$var$interceptClone,
    addScopeToNode: $4180c5bc1a83c67d$var$addScopeToNode,
    deferMutations: $4180c5bc1a83c67d$var$deferMutations,
    mapAttributes: $4180c5bc1a83c67d$var$mapAttributes,
    evaluateLater: $4180c5bc1a83c67d$var$evaluateLater,
    interceptInit: $4180c5bc1a83c67d$var$interceptInit,
    setEvaluator: $4180c5bc1a83c67d$var$setEvaluator,
    mergeProxies: $4180c5bc1a83c67d$var$mergeProxies,
    extractProp: $4180c5bc1a83c67d$var$extractProp,
    findClosest: $4180c5bc1a83c67d$var$findClosest,
    onElRemoved: $4180c5bc1a83c67d$var$onElRemoved,
    closestRoot: $4180c5bc1a83c67d$var$closestRoot,
    destroyTree: $4180c5bc1a83c67d$var$destroyTree,
    interceptor: $4180c5bc1a83c67d$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $4180c5bc1a83c67d$var$transition,
    setStyles: // INTERNAL
    $4180c5bc1a83c67d$var$setStyles,
    mutateDom: // INTERNAL
    $4180c5bc1a83c67d$var$mutateDom,
    directive: $4180c5bc1a83c67d$var$directive,
    entangle: $4180c5bc1a83c67d$var$entangle,
    throttle: $4180c5bc1a83c67d$var$throttle,
    debounce: $4180c5bc1a83c67d$var$debounce,
    evaluate: $4180c5bc1a83c67d$var$evaluate,
    initTree: $4180c5bc1a83c67d$var$initTree,
    nextTick: $4180c5bc1a83c67d$var$nextTick,
    prefixed: $4180c5bc1a83c67d$var$prefix,
    prefix: $4180c5bc1a83c67d$var$setPrefix,
    plugin: $4180c5bc1a83c67d$var$plugin,
    magic: $4180c5bc1a83c67d$var$magic,
    store: $4180c5bc1a83c67d$var$store,
    start: $4180c5bc1a83c67d$var$start,
    clone: $4180c5bc1a83c67d$var$clone,
    cloneNode: // INTERNAL
    $4180c5bc1a83c67d$var$cloneNode,
    // INTERNAL
    bound: $4180c5bc1a83c67d$var$getBinding,
    $data: $4180c5bc1a83c67d$var$scope,
    watch: $4180c5bc1a83c67d$var$watch,
    walk: $4180c5bc1a83c67d$var$walk,
    data: $4180c5bc1a83c67d$var$data,
    bind: $4180c5bc1a83c67d$var$bind2
};
var $4180c5bc1a83c67d$var$alpine_default = $4180c5bc1a83c67d$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $4180c5bc1a83c67d$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $4180c5bc1a83c67d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $4180c5bc1a83c67d$var$isBooleanAttr2 = /* @__PURE__ */ $4180c5bc1a83c67d$var$makeMap($4180c5bc1a83c67d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $4180c5bc1a83c67d$var$EMPTY_OBJ = Object.freeze({});
var $4180c5bc1a83c67d$var$EMPTY_ARR = Object.freeze([]);
var $4180c5bc1a83c67d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $4180c5bc1a83c67d$var$hasOwn = (val, key)=>$4180c5bc1a83c67d$var$hasOwnProperty.call(val, key);
var $4180c5bc1a83c67d$var$isArray = Array.isArray;
var $4180c5bc1a83c67d$var$isMap = (val)=>$4180c5bc1a83c67d$var$toTypeString(val) === "[object Map]";
var $4180c5bc1a83c67d$var$isString = (val)=>typeof val === "string";
var $4180c5bc1a83c67d$var$isSymbol = (val)=>typeof val === "symbol";
var $4180c5bc1a83c67d$var$isObject = (val)=>val !== null && typeof val === "object";
var $4180c5bc1a83c67d$var$objectToString = Object.prototype.toString;
var $4180c5bc1a83c67d$var$toTypeString = (value)=>$4180c5bc1a83c67d$var$objectToString.call(value);
var $4180c5bc1a83c67d$var$toRawType = (value)=>{
    return $4180c5bc1a83c67d$var$toTypeString(value).slice(8, -1);
};
var $4180c5bc1a83c67d$var$isIntegerKey = (key)=>$4180c5bc1a83c67d$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $4180c5bc1a83c67d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $4180c5bc1a83c67d$var$camelizeRE = /-(\w)/g;
var $4180c5bc1a83c67d$var$camelize = $4180c5bc1a83c67d$var$cacheStringFunction((str)=>{
    return str.replace($4180c5bc1a83c67d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $4180c5bc1a83c67d$var$hyphenateRE = /\B([A-Z])/g;
var $4180c5bc1a83c67d$var$hyphenate = $4180c5bc1a83c67d$var$cacheStringFunction((str)=>str.replace($4180c5bc1a83c67d$var$hyphenateRE, "-$1").toLowerCase());
var $4180c5bc1a83c67d$var$capitalize = $4180c5bc1a83c67d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $4180c5bc1a83c67d$var$toHandlerKey = $4180c5bc1a83c67d$var$cacheStringFunction((str)=>str ? `on${$4180c5bc1a83c67d$var$capitalize(str)}` : ``);
var $4180c5bc1a83c67d$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $4180c5bc1a83c67d$var$targetMap = /* @__PURE__ */ new WeakMap();
var $4180c5bc1a83c67d$var$effectStack = [];
var $4180c5bc1a83c67d$var$activeEffect;
var $4180c5bc1a83c67d$var$ITERATE_KEY = Symbol("iterate");
var $4180c5bc1a83c67d$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $4180c5bc1a83c67d$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $4180c5bc1a83c67d$var$effect2(fn, options = $4180c5bc1a83c67d$var$EMPTY_OBJ) {
    if ($4180c5bc1a83c67d$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $4180c5bc1a83c67d$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $4180c5bc1a83c67d$var$stop(effect3) {
    if (effect3.active) {
        $4180c5bc1a83c67d$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $4180c5bc1a83c67d$var$uid = 0;
function $4180c5bc1a83c67d$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$4180c5bc1a83c67d$var$effectStack.includes(effect3)) {
            $4180c5bc1a83c67d$var$cleanup(effect3);
            try {
                $4180c5bc1a83c67d$var$enableTracking();
                $4180c5bc1a83c67d$var$effectStack.push(effect3);
                $4180c5bc1a83c67d$var$activeEffect = effect3;
                return fn();
            } finally{
                $4180c5bc1a83c67d$var$effectStack.pop();
                $4180c5bc1a83c67d$var$resetTracking();
                $4180c5bc1a83c67d$var$activeEffect = $4180c5bc1a83c67d$var$effectStack[$4180c5bc1a83c67d$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $4180c5bc1a83c67d$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $4180c5bc1a83c67d$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $4180c5bc1a83c67d$var$shouldTrack = true;
var $4180c5bc1a83c67d$var$trackStack = [];
function $4180c5bc1a83c67d$var$pauseTracking() {
    $4180c5bc1a83c67d$var$trackStack.push($4180c5bc1a83c67d$var$shouldTrack);
    $4180c5bc1a83c67d$var$shouldTrack = false;
}
function $4180c5bc1a83c67d$var$enableTracking() {
    $4180c5bc1a83c67d$var$trackStack.push($4180c5bc1a83c67d$var$shouldTrack);
    $4180c5bc1a83c67d$var$shouldTrack = true;
}
function $4180c5bc1a83c67d$var$resetTracking() {
    const last = $4180c5bc1a83c67d$var$trackStack.pop();
    $4180c5bc1a83c67d$var$shouldTrack = last === void 0 ? true : last;
}
function $4180c5bc1a83c67d$var$track(target, type, key) {
    if (!$4180c5bc1a83c67d$var$shouldTrack || $4180c5bc1a83c67d$var$activeEffect === void 0) return;
    let depsMap = $4180c5bc1a83c67d$var$targetMap.get(target);
    if (!depsMap) $4180c5bc1a83c67d$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($4180c5bc1a83c67d$var$activeEffect)) {
        dep.add($4180c5bc1a83c67d$var$activeEffect);
        $4180c5bc1a83c67d$var$activeEffect.deps.push(dep);
        if ($4180c5bc1a83c67d$var$activeEffect.options.onTrack) $4180c5bc1a83c67d$var$activeEffect.options.onTrack({
            effect: $4180c5bc1a83c67d$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $4180c5bc1a83c67d$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $4180c5bc1a83c67d$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $4180c5bc1a83c67d$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $4180c5bc1a83c67d$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$4180c5bc1a83c67d$var$isArray(target)) {
                    add2(depsMap.get($4180c5bc1a83c67d$var$ITERATE_KEY));
                    if ($4180c5bc1a83c67d$var$isMap(target)) add2(depsMap.get($4180c5bc1a83c67d$var$MAP_KEY_ITERATE_KEY));
                } else if ($4180c5bc1a83c67d$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$4180c5bc1a83c67d$var$isArray(target)) {
                    add2(depsMap.get($4180c5bc1a83c67d$var$ITERATE_KEY));
                    if ($4180c5bc1a83c67d$var$isMap(target)) add2(depsMap.get($4180c5bc1a83c67d$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($4180c5bc1a83c67d$var$isMap(target)) add2(depsMap.get($4180c5bc1a83c67d$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $4180c5bc1a83c67d$var$isNonTrackableKeys = /* @__PURE__ */ $4180c5bc1a83c67d$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $4180c5bc1a83c67d$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($4180c5bc1a83c67d$var$isSymbol));
var $4180c5bc1a83c67d$var$get2 = /* @__PURE__ */ $4180c5bc1a83c67d$var$createGetter();
var $4180c5bc1a83c67d$var$readonlyGet = /* @__PURE__ */ $4180c5bc1a83c67d$var$createGetter(true);
var $4180c5bc1a83c67d$var$arrayInstrumentations = /* @__PURE__ */ $4180c5bc1a83c67d$var$createArrayInstrumentations();
function $4180c5bc1a83c67d$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $4180c5bc1a83c67d$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$4180c5bc1a83c67d$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($4180c5bc1a83c67d$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $4180c5bc1a83c67d$var$pauseTracking();
            const res = $4180c5bc1a83c67d$var$toRaw(this)[key].apply(this, args);
            $4180c5bc1a83c67d$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $4180c5bc1a83c67d$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $4180c5bc1a83c67d$var$shallowReadonlyMap : $4180c5bc1a83c67d$var$readonlyMap : shallow ? $4180c5bc1a83c67d$var$shallowReactiveMap : $4180c5bc1a83c67d$var$reactiveMap).get(target)) return target;
        const targetIsArray = $4180c5bc1a83c67d$var$isArray(target);
        if (!isReadonly && targetIsArray && $4180c5bc1a83c67d$var$hasOwn($4180c5bc1a83c67d$var$arrayInstrumentations, key)) return Reflect.get($4180c5bc1a83c67d$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($4180c5bc1a83c67d$var$isSymbol(key) ? $4180c5bc1a83c67d$var$builtInSymbols.has(key) : $4180c5bc1a83c67d$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $4180c5bc1a83c67d$var$track(target, "get", key);
        if (shallow) return res;
        if ($4180c5bc1a83c67d$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$4180c5bc1a83c67d$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($4180c5bc1a83c67d$var$isObject(res)) return isReadonly ? $4180c5bc1a83c67d$var$readonly(res) : $4180c5bc1a83c67d$var$reactive2(res);
        return res;
    };
}
var $4180c5bc1a83c67d$var$set2 = /* @__PURE__ */ $4180c5bc1a83c67d$var$createSetter();
function $4180c5bc1a83c67d$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $4180c5bc1a83c67d$var$toRaw(value);
            oldValue = $4180c5bc1a83c67d$var$toRaw(oldValue);
            if (!$4180c5bc1a83c67d$var$isArray(target) && $4180c5bc1a83c67d$var$isRef(oldValue) && !$4180c5bc1a83c67d$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $4180c5bc1a83c67d$var$isArray(target) && $4180c5bc1a83c67d$var$isIntegerKey(key) ? Number(key) < target.length : $4180c5bc1a83c67d$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $4180c5bc1a83c67d$var$toRaw(receiver)) {
            if (!hadKey) $4180c5bc1a83c67d$var$trigger(target, "add", key, value);
            else if ($4180c5bc1a83c67d$var$hasChanged(value, oldValue)) $4180c5bc1a83c67d$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $4180c5bc1a83c67d$var$deleteProperty(target, key) {
    const hadKey = $4180c5bc1a83c67d$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $4180c5bc1a83c67d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $4180c5bc1a83c67d$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$4180c5bc1a83c67d$var$isSymbol(key) || !$4180c5bc1a83c67d$var$builtInSymbols.has(key)) $4180c5bc1a83c67d$var$track(target, "has", key);
    return result;
}
function $4180c5bc1a83c67d$var$ownKeys(target) {
    $4180c5bc1a83c67d$var$track(target, "iterate", $4180c5bc1a83c67d$var$isArray(target) ? "length" : $4180c5bc1a83c67d$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $4180c5bc1a83c67d$var$mutableHandlers = {
    get: $4180c5bc1a83c67d$var$get2,
    set: $4180c5bc1a83c67d$var$set2,
    deleteProperty: $4180c5bc1a83c67d$var$deleteProperty,
    has: $4180c5bc1a83c67d$var$has,
    ownKeys: $4180c5bc1a83c67d$var$ownKeys
};
var $4180c5bc1a83c67d$var$readonlyHandlers = {
    get: $4180c5bc1a83c67d$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $4180c5bc1a83c67d$var$toReactive = (value)=>$4180c5bc1a83c67d$var$isObject(value) ? $4180c5bc1a83c67d$var$reactive2(value) : value;
var $4180c5bc1a83c67d$var$toReadonly = (value)=>$4180c5bc1a83c67d$var$isObject(value) ? $4180c5bc1a83c67d$var$readonly(value) : value;
var $4180c5bc1a83c67d$var$toShallow = (value)=>value;
var $4180c5bc1a83c67d$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $4180c5bc1a83c67d$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $4180c5bc1a83c67d$var$toRaw(target);
    const rawKey = $4180c5bc1a83c67d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $4180c5bc1a83c67d$var$track(rawTarget, "get", key);
    !isReadonly && $4180c5bc1a83c67d$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $4180c5bc1a83c67d$var$getProto(rawTarget);
    const wrap = isShallow ? $4180c5bc1a83c67d$var$toShallow : isReadonly ? $4180c5bc1a83c67d$var$toReadonly : $4180c5bc1a83c67d$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $4180c5bc1a83c67d$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $4180c5bc1a83c67d$var$toRaw(target);
    const rawKey = $4180c5bc1a83c67d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $4180c5bc1a83c67d$var$track(rawTarget, "has", key);
    !isReadonly && $4180c5bc1a83c67d$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $4180c5bc1a83c67d$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $4180c5bc1a83c67d$var$track($4180c5bc1a83c67d$var$toRaw(target), "iterate", $4180c5bc1a83c67d$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $4180c5bc1a83c67d$var$add(value) {
    value = $4180c5bc1a83c67d$var$toRaw(value);
    const target = $4180c5bc1a83c67d$var$toRaw(this);
    const proto = $4180c5bc1a83c67d$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $4180c5bc1a83c67d$var$trigger(target, "add", value, value);
    }
    return this;
}
function $4180c5bc1a83c67d$var$set$1(key, value) {
    value = $4180c5bc1a83c67d$var$toRaw(value);
    const target = $4180c5bc1a83c67d$var$toRaw(this);
    const { has: has2, get: get3 } = $4180c5bc1a83c67d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $4180c5bc1a83c67d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $4180c5bc1a83c67d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $4180c5bc1a83c67d$var$trigger(target, "add", key, value);
    else if ($4180c5bc1a83c67d$var$hasChanged(value, oldValue)) $4180c5bc1a83c67d$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $4180c5bc1a83c67d$var$deleteEntry(key) {
    const target = $4180c5bc1a83c67d$var$toRaw(this);
    const { has: has2, get: get3 } = $4180c5bc1a83c67d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $4180c5bc1a83c67d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $4180c5bc1a83c67d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $4180c5bc1a83c67d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $4180c5bc1a83c67d$var$clear() {
    const target = $4180c5bc1a83c67d$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $4180c5bc1a83c67d$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $4180c5bc1a83c67d$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $4180c5bc1a83c67d$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $4180c5bc1a83c67d$var$toRaw(target);
        const wrap = isShallow ? $4180c5bc1a83c67d$var$toShallow : isReadonly ? $4180c5bc1a83c67d$var$toReadonly : $4180c5bc1a83c67d$var$toReactive;
        !isReadonly && $4180c5bc1a83c67d$var$track(rawTarget, "iterate", $4180c5bc1a83c67d$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $4180c5bc1a83c67d$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $4180c5bc1a83c67d$var$toRaw(target);
        const targetIsMap = $4180c5bc1a83c67d$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $4180c5bc1a83c67d$var$toShallow : isReadonly ? $4180c5bc1a83c67d$var$toReadonly : $4180c5bc1a83c67d$var$toReactive;
        !isReadonly && $4180c5bc1a83c67d$var$track(rawTarget, "iterate", isKeyOnly ? $4180c5bc1a83c67d$var$MAP_KEY_ITERATE_KEY : $4180c5bc1a83c67d$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $4180c5bc1a83c67d$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$4180c5bc1a83c67d$var$capitalize(type)} operation ${key}failed: target is readonly.`, $4180c5bc1a83c67d$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $4180c5bc1a83c67d$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $4180c5bc1a83c67d$var$get$1(this, key);
        },
        get size () {
            return $4180c5bc1a83c67d$var$size(this);
        },
        has: $4180c5bc1a83c67d$var$has$1,
        add: $4180c5bc1a83c67d$var$add,
        set: $4180c5bc1a83c67d$var$set$1,
        delete: $4180c5bc1a83c67d$var$deleteEntry,
        clear: $4180c5bc1a83c67d$var$clear,
        forEach: $4180c5bc1a83c67d$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $4180c5bc1a83c67d$var$get$1(this, key, false, true);
        },
        get size () {
            return $4180c5bc1a83c67d$var$size(this);
        },
        has: $4180c5bc1a83c67d$var$has$1,
        add: $4180c5bc1a83c67d$var$add,
        set: $4180c5bc1a83c67d$var$set$1,
        delete: $4180c5bc1a83c67d$var$deleteEntry,
        clear: $4180c5bc1a83c67d$var$clear,
        forEach: $4180c5bc1a83c67d$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $4180c5bc1a83c67d$var$get$1(this, key, true);
        },
        get size () {
            return $4180c5bc1a83c67d$var$size(this, true);
        },
        has (key) {
            return $4180c5bc1a83c67d$var$has$1.call(this, key, true);
        },
        add: $4180c5bc1a83c67d$var$createReadonlyMethod("add"),
        set: $4180c5bc1a83c67d$var$createReadonlyMethod("set"),
        delete: $4180c5bc1a83c67d$var$createReadonlyMethod("delete"),
        clear: $4180c5bc1a83c67d$var$createReadonlyMethod("clear"),
        forEach: $4180c5bc1a83c67d$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $4180c5bc1a83c67d$var$get$1(this, key, true, true);
        },
        get size () {
            return $4180c5bc1a83c67d$var$size(this, true);
        },
        has (key) {
            return $4180c5bc1a83c67d$var$has$1.call(this, key, true);
        },
        add: $4180c5bc1a83c67d$var$createReadonlyMethod("add"),
        set: $4180c5bc1a83c67d$var$createReadonlyMethod("set"),
        delete: $4180c5bc1a83c67d$var$createReadonlyMethod("delete"),
        clear: $4180c5bc1a83c67d$var$createReadonlyMethod("clear"),
        forEach: $4180c5bc1a83c67d$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $4180c5bc1a83c67d$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $4180c5bc1a83c67d$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $4180c5bc1a83c67d$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $4180c5bc1a83c67d$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$4180c5bc1a83c67d$var$mutableInstrumentations, $4180c5bc1a83c67d$var$readonlyInstrumentations, $4180c5bc1a83c67d$var$shallowInstrumentations, $4180c5bc1a83c67d$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $4180c5bc1a83c67d$var$createInstrumentations();
function $4180c5bc1a83c67d$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $4180c5bc1a83c67d$var$shallowReadonlyInstrumentations : $4180c5bc1a83c67d$var$shallowInstrumentations : isReadonly ? $4180c5bc1a83c67d$var$readonlyInstrumentations : $4180c5bc1a83c67d$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($4180c5bc1a83c67d$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $4180c5bc1a83c67d$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $4180c5bc1a83c67d$var$createInstrumentationGetter(false, false)
};
var $4180c5bc1a83c67d$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $4180c5bc1a83c67d$var$createInstrumentationGetter(true, false)
};
function $4180c5bc1a83c67d$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $4180c5bc1a83c67d$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $4180c5bc1a83c67d$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $4180c5bc1a83c67d$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $4180c5bc1a83c67d$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $4180c5bc1a83c67d$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $4180c5bc1a83c67d$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $4180c5bc1a83c67d$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $4180c5bc1a83c67d$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $4180c5bc1a83c67d$var$targetTypeMap($4180c5bc1a83c67d$var$toRawType(value));
}
function $4180c5bc1a83c67d$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $4180c5bc1a83c67d$var$createReactiveObject(target, false, $4180c5bc1a83c67d$var$mutableHandlers, $4180c5bc1a83c67d$var$mutableCollectionHandlers, $4180c5bc1a83c67d$var$reactiveMap);
}
function $4180c5bc1a83c67d$var$readonly(target) {
    return $4180c5bc1a83c67d$var$createReactiveObject(target, true, $4180c5bc1a83c67d$var$readonlyHandlers, $4180c5bc1a83c67d$var$readonlyCollectionHandlers, $4180c5bc1a83c67d$var$readonlyMap);
}
function $4180c5bc1a83c67d$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$4180c5bc1a83c67d$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $4180c5bc1a83c67d$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $4180c5bc1a83c67d$var$toRaw(observed) {
    return observed && $4180c5bc1a83c67d$var$toRaw(observed["__v_raw"]) || observed;
}
function $4180c5bc1a83c67d$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$4180c5bc1a83c67d$var$magic("nextTick", ()=>$4180c5bc1a83c67d$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$4180c5bc1a83c67d$var$magic("dispatch", (el)=>$4180c5bc1a83c67d$var$dispatch.bind($4180c5bc1a83c67d$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$4180c5bc1a83c67d$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $4180c5bc1a83c67d$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$4180c5bc1a83c67d$var$magic("store", $4180c5bc1a83c67d$var$getStores);
// packages/alpinejs/src/magics/$data.js
$4180c5bc1a83c67d$var$magic("data", (el)=>$4180c5bc1a83c67d$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$4180c5bc1a83c67d$var$magic("root", (el)=>$4180c5bc1a83c67d$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$4180c5bc1a83c67d$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $4180c5bc1a83c67d$var$mergeProxies($4180c5bc1a83c67d$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $4180c5bc1a83c67d$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $4180c5bc1a83c67d$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $4180c5bc1a83c67d$var$globalIdMemo = {};
function $4180c5bc1a83c67d$var$findAndIncrementId(name) {
    if (!$4180c5bc1a83c67d$var$globalIdMemo[name]) $4180c5bc1a83c67d$var$globalIdMemo[name] = 0;
    return ++$4180c5bc1a83c67d$var$globalIdMemo[name];
}
function $4180c5bc1a83c67d$var$closestIdRoot(el, name) {
    return $4180c5bc1a83c67d$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $4180c5bc1a83c67d$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $4180c5bc1a83c67d$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$4180c5bc1a83c67d$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $4180c5bc1a83c67d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $4180c5bc1a83c67d$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $4180c5bc1a83c67d$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$4180c5bc1a83c67d$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $4180c5bc1a83c67d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$4180c5bc1a83c67d$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$4180c5bc1a83c67d$var$warnMissingPluginMagic("Focus", "focus", "focus");
$4180c5bc1a83c67d$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $4180c5bc1a83c67d$var$warnMissingPluginMagic(name, magicName, slug) {
    $4180c5bc1a83c67d$var$magic(magicName, (el)=>$4180c5bc1a83c67d$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$4180c5bc1a83c67d$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $4180c5bc1a83c67d$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$4180c5bc1a83c67d$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $4180c5bc1a83c67d$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $4180c5bc1a83c67d$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $4180c5bc1a83c67d$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $4180c5bc1a83c67d$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $4180c5bc1a83c67d$var$skipDuringClone(()=>{
            $4180c5bc1a83c67d$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $4180c5bc1a83c67d$var$getTarget(expression);
        $4180c5bc1a83c67d$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$4180c5bc1a83c67d$var$mutateDom(()=>{
            clone2.remove();
            $4180c5bc1a83c67d$var$destroyTree(clone2);
        }));
});
var $4180c5bc1a83c67d$var$teleportContainerDuringClone = document.createElement("div");
function $4180c5bc1a83c67d$var$getTarget(expression) {
    let target = $4180c5bc1a83c67d$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $4180c5bc1a83c67d$var$teleportContainerDuringClone;
    })();
    if (!target) $4180c5bc1a83c67d$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $4180c5bc1a83c67d$var$handler = ()=>{};
$4180c5bc1a83c67d$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$4180c5bc1a83c67d$var$directive("ignore", $4180c5bc1a83c67d$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$4180c5bc1a83c67d$var$directive("effect", $4180c5bc1a83c67d$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($4180c5bc1a83c67d$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $4180c5bc1a83c67d$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $4180c5bc1a83c67d$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $4180c5bc1a83c67d$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $4180c5bc1a83c67d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $4180c5bc1a83c67d$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $4180c5bc1a83c67d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $4180c5bc1a83c67d$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($4180c5bc1a83c67d$var$isKeyEvent(event) || $4180c5bc1a83c67d$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($4180c5bc1a83c67d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $4180c5bc1a83c67d$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $4180c5bc1a83c67d$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $4180c5bc1a83c67d$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $4180c5bc1a83c67d$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $4180c5bc1a83c67d$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $4180c5bc1a83c67d$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $4180c5bc1a83c67d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $4180c5bc1a83c67d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $4180c5bc1a83c67d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $4180c5bc1a83c67d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($4180c5bc1a83c67d$var$isClickEvent(e.type)) return false;
            if ($4180c5bc1a83c67d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $4180c5bc1a83c67d$var$keyToModifiers(key) {
    if (!key) return [];
    key = $4180c5bc1a83c67d$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$4180c5bc1a83c67d$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $4180c5bc1a83c67d$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $4180c5bc1a83c67d$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $4180c5bc1a83c67d$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $4180c5bc1a83c67d$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($4180c5bc1a83c67d$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $4180c5bc1a83c67d$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $4180c5bc1a83c67d$var$isCloning ? ()=>{} : $4180c5bc1a83c67d$var$on(el, event, modifiers, (e)=>{
        setValue($4180c5bc1a83c67d$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $4180c5bc1a83c67d$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($4180c5bc1a83c67d$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $4180c5bc1a83c67d$var$on(el.form, "reset", [], (e)=>{
            $4180c5bc1a83c67d$var$nextTick(()=>el._x_model && el._x_model.set($4180c5bc1a83c67d$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $4180c5bc1a83c67d$var$mutateDom(()=>$4180c5bc1a83c67d$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $4180c5bc1a83c67d$var$getInputValue(el, modifiers, event, currentValue) {
    return $4180c5bc1a83c67d$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($4180c5bc1a83c67d$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $4180c5bc1a83c67d$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $4180c5bc1a83c67d$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$4180c5bc1a83c67d$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $4180c5bc1a83c67d$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $4180c5bc1a83c67d$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($4180c5bc1a83c67d$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $4180c5bc1a83c67d$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $4180c5bc1a83c67d$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $4180c5bc1a83c67d$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $4180c5bc1a83c67d$var$isNumeric2(number) ? number : rawValue;
}
function $4180c5bc1a83c67d$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $4180c5bc1a83c67d$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $4180c5bc1a83c67d$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$4180c5bc1a83c67d$var$directive("cloak", (el)=>queueMicrotask(()=>$4180c5bc1a83c67d$var$mutateDom(()=>el.removeAttribute($4180c5bc1a83c67d$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$4180c5bc1a83c67d$var$addInitSelector(()=>`[${$4180c5bc1a83c67d$var$prefix("init")}]`);
$4180c5bc1a83c67d$var$directive("init", $4180c5bc1a83c67d$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$4180c5bc1a83c67d$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $4180c5bc1a83c67d$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$4180c5bc1a83c67d$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $4180c5bc1a83c67d$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $4180c5bc1a83c67d$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$4180c5bc1a83c67d$var$mapAttributes($4180c5bc1a83c67d$var$startingWith(":", $4180c5bc1a83c67d$var$into($4180c5bc1a83c67d$var$prefix("bind:"))));
var $4180c5bc1a83c67d$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $4180c5bc1a83c67d$var$injectBindingProviders(bindingProviders);
        let getBindings = $4180c5bc1a83c67d$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $4180c5bc1a83c67d$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $4180c5bc1a83c67d$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $4180c5bc1a83c67d$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $4180c5bc1a83c67d$var$mutateDom(()=>$4180c5bc1a83c67d$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$4180c5bc1a83c67d$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$4180c5bc1a83c67d$var$directive("bind", $4180c5bc1a83c67d$var$handler2);
function $4180c5bc1a83c67d$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$4180c5bc1a83c67d$var$addRootSelector(()=>`[${$4180c5bc1a83c67d$var$prefix("data")}]`);
$4180c5bc1a83c67d$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($4180c5bc1a83c67d$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $4180c5bc1a83c67d$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $4180c5bc1a83c67d$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $4180c5bc1a83c67d$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $4180c5bc1a83c67d$var$injectMagics(data2, el);
    let reactiveData = $4180c5bc1a83c67d$var$reactive(data2);
    $4180c5bc1a83c67d$var$initInterceptors(reactiveData);
    let undo = $4180c5bc1a83c67d$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $4180c5bc1a83c67d$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $4180c5bc1a83c67d$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$4180c5bc1a83c67d$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $4180c5bc1a83c67d$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$4180c5bc1a83c67d$var$isCloning) return false;
    if ($4180c5bc1a83c67d$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$4180c5bc1a83c67d$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $4180c5bc1a83c67d$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $4180c5bc1a83c67d$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $4180c5bc1a83c67d$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $4180c5bc1a83c67d$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$4180c5bc1a83c67d$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $4180c5bc1a83c67d$var$parseForExpression(expression);
    let evaluateItems = $4180c5bc1a83c67d$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $4180c5bc1a83c67d$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$4180c5bc1a83c67d$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$4180c5bc1a83c67d$var$mutateDom(()=>{
                $4180c5bc1a83c67d$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $4180c5bc1a83c67d$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($4180c5bc1a83c67d$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $4180c5bc1a83c67d$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $4180c5bc1a83c67d$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $4180c5bc1a83c67d$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $4180c5bc1a83c67d$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $4180c5bc1a83c67d$var$mutateDom(()=>{
                $4180c5bc1a83c67d$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $4180c5bc1a83c67d$var$mutateDom(()=>{
                if (!elForSpot) $4180c5bc1a83c67d$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $4180c5bc1a83c67d$var$reactive(scope2);
            $4180c5bc1a83c67d$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $4180c5bc1a83c67d$var$mutateDom(()=>{
                lastEl.after(clone2);
                $4180c5bc1a83c67d$var$skipDuringClone(()=>$4180c5bc1a83c67d$var$initTree(clone2))();
            });
            if (typeof key === "object") $4180c5bc1a83c67d$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $4180c5bc1a83c67d$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $4180c5bc1a83c67d$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $4180c5bc1a83c67d$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $4180c5bc1a83c67d$var$handler3() {}
$4180c5bc1a83c67d$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $4180c5bc1a83c67d$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$4180c5bc1a83c67d$var$directive("ref", $4180c5bc1a83c67d$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$4180c5bc1a83c67d$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $4180c5bc1a83c67d$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $4180c5bc1a83c67d$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $4180c5bc1a83c67d$var$addScopeToNode(clone2, {}, el);
        $4180c5bc1a83c67d$var$mutateDom(()=>{
            el.after(clone2);
            $4180c5bc1a83c67d$var$skipDuringClone(()=>$4180c5bc1a83c67d$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $4180c5bc1a83c67d$var$mutateDom(()=>{
                $4180c5bc1a83c67d$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$4180c5bc1a83c67d$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$4180c5bc1a83c67d$var$setIdRoot(el, name));
});
$4180c5bc1a83c67d$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$4180c5bc1a83c67d$var$mapAttributes($4180c5bc1a83c67d$var$startingWith("@", $4180c5bc1a83c67d$var$into($4180c5bc1a83c67d$var$prefix("on:"))));
$4180c5bc1a83c67d$var$directive("on", $4180c5bc1a83c67d$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $4180c5bc1a83c67d$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $4180c5bc1a83c67d$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$4180c5bc1a83c67d$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$4180c5bc1a83c67d$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$4180c5bc1a83c67d$var$warnMissingPluginDirective("Focus", "trap", "focus");
$4180c5bc1a83c67d$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $4180c5bc1a83c67d$var$warnMissingPluginDirective(name, directiveName, slug) {
    $4180c5bc1a83c67d$var$directive(directiveName, (el)=>$4180c5bc1a83c67d$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$4180c5bc1a83c67d$var$alpine_default.setEvaluator($4180c5bc1a83c67d$var$normalEvaluator);
$4180c5bc1a83c67d$var$alpine_default.setReactivityEngine({
    reactive: $4180c5bc1a83c67d$var$reactive2,
    effect: $4180c5bc1a83c67d$var$effect2,
    release: $4180c5bc1a83c67d$var$stop,
    raw: $4180c5bc1a83c67d$var$toRaw
});
var $4180c5bc1a83c67d$export$b7ee041e4ad2afec = $4180c5bc1a83c67d$var$alpine_default;
// packages/alpinejs/builds/module.js
var $4180c5bc1a83c67d$export$2e2bcd8739ae039 = $4180c5bc1a83c67d$export$b7ee041e4ad2afec;


var $03c9da05328e6bab$exports = {};
var $fe73a17690f42ba9$exports = {};
window.TzOffsetController = function() {
    // The native timezone offset gives us the number of minutes that we'd have to add to
    // the LOCAL time in order to get the UTC time. However, we're going to use this on
    // the server, where we're already in UTC time. As such, in order to make the date
    // maths easier, we want to store the INVERSE OFFSET such that we can calculate the
    // LOCAL time from the UTC time.
    this.$el.value = -new Date().getTimezoneOffset();
};


$03c9da05328e6bab$exports = {
    "tzHelper": $fe73a17690f42ba9$exports
};


var $20647d6030f59c56$exports = {};
var $b52e6f1093ca412c$exports = {};
// Import module styles.

// Define controllers.
window.pm14ud = {
    ErrorMessage: $b52e6f1093ca412c$var$ErrorMessage
};
function $b52e6f1093ca412c$var$ErrorMessage() {
    return {
        init: $init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    function $init() {
        this.$el.focus();
        this.$refs.scrollTarget.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
}


var $c140a07e1815a238$exports = {};
// Import module styles.

// Define controllers.
window.owvqva = {
    FlashMessage: $c140a07e1815a238$var$FlashMessage
};
function $c140a07e1815a238$var$FlashMessage() {
    return {
        init: init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
        // In order to make sure that the page doesn't continue to show the flash message
        // on navigation (back/forward/refresh), we're going to replace the current item
        // on the history stack.
        var url = new URL(window.location.href);
        url.searchParams.delete("flash");
        url.searchParams.delete("flashData");
        window.history.replaceState({}, "", url);
        // Focus the flash message as well.
        this.$el.focus();
    }
}


var $65ee7748ed1fcee1$exports = {};
// Import module styles.



var $82936e26418b3eb9$exports = {};
// Define controllers.
window.lzlbk2 = {
    FormController: $82936e26418b3eb9$var$FormController
};
function $82936e26418b3eb9$var$FormController() {
    return {
        // Public properties.
        isSubmitting: false,
        // Public methods.
        init: $init,
        handleSubmit: handleSubmit
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the form.
	*/ function $init() {
        this.$el.requestSubmit(this.$refs.button);
    }
    /**
	* I handle the form submission, making sure a double-submission isn't possible.
	*/ function handleSubmit(event) {
        if (this.isSubmitting) {
            event.preventDefault();
            return;
        }
        this.isSubmitting = true;
    }
}


var $f0f46394c28034e1$exports = {};
// Import module styles.

// Define controllers.
window.e0pw7v = {
    NavController: $f0f46394c28034e1$var$NavController
};
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $f0f46394c28034e1$var$NavController() {
    return {
        // Public properties.
        isOpen: false,
        // Public methods.
        toggleMenu: toggleMenu
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I manage the opening / closing of the menu on narrow devices.
	*/ function toggleMenu() {
        this.isOpen = !this.isOpen;
    }
}


var $b5f661c94b864ab5$exports = {};
// Import module styles.

var $5874c6f4fbf644a5$export$d845b2147404936a = function() {
    return {
        isFuzzyMatch: isFuzzyMatch,
        isFuzzyMatchMulti: isFuzzyMatchMulti,
        normalizePipeText: normalizePipeText,
        normalizeText: normalizeText
    };
    // ---
    // PUBLIC METHODS.
    // ---
    function isFuzzyMatch(target, keywords) {
        if (!keywords) return true;
        var targetChars = [
            ...target
        ];
        var searchChars = [
            ...keywords
        ];
        var searchChar = null;
        var targetChar = null;
        while(searchChar = searchChars.shift()){
            while(targetChar = targetChars.shift())if (targetChar === searchChar) {
                if (!searchChars.length) return true;
                break;
            }
            if (!targetChars.length) break;
        }
        return false;
    }
    function isFuzzyMatchMulti(targets, keywords) {
        if (!keywords) return true;
        for (var target of targets){
            if (isFuzzyMatch(target, keywords)) return true;
        }
        return false;
    }
    function normalizePipeText(input) {
        var parts = input.split("|").map((part)=>normalizeText(part)).filter((part)=>part.length);
        return parts;
    }
    function normalizeText(input) {
        return input.toLowerCase().replace(/[^\w|]+/g, "").trim();
    }
}();
var $5874c6f4fbf644a5$export$2e2bcd8739ae039 = $5874c6f4fbf644a5$export$d845b2147404936a;


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.dxp6cs = {
    FormController: $b5f661c94b864ab5$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $b5f661c94b864ab5$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $5d1d409dc9148d62$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.i53zyu = {
    FormController: $5d1d409dc9148d62$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $5d1d409dc9148d62$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $e9cf01e1174e3df2$exports = {};
// Import module styles.



var $9c580889636c49f4$exports = {};
// Import module styles.



var $a8ffad4a264ddcd3$exports = {};
// Import module styles.

// Define controllers.
window.vyykfq = {
    FormController: $a8ffad4a264ddcd3$var$FormController
};
function $a8ffad4a264ddcd3$var$FormController() {
    var host = this.$el;
    var prompts = host.querySelectorAll(".prompt-info");
    return {
        init: $init,
        syncInfoNodes: syncInfoNodes
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the form component.
	*/ function $init() {
        this.syncInfoNodes();
    }
    /**
	* I synchronize the prompt info rendering with the select.
	*/ function syncInfoNodes() {
        var value = this.$refs.select.value;
        for (var prompt of prompts){
            prompt.classList.remove("is-active");
            if (prompt.dataset.promptId === value) prompt.classList.add("is-active");
        }
    }
}


var $b35af2c19aa8f428$exports = {};
// Import module styles.



var $d0655391e575531c$exports = {};
// Import module styles.



var $a5360da36d2ffc34$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.tsjor3 = {
    FormController: $a5360da36d2ffc34$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $a5360da36d2ffc34$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $11a23512afed2076$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.oc21uc = {
    FormController: $11a23512afed2076$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $11a23512afed2076$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $4b0dca4e96bf7b58$exports = {};



var $644bb84d187ce460$exports = {};
// Import module styles.

// Define controllers.
window.zwdz6r = {
    FormController: $644bb84d187ce460$var$FormController
};
function $644bb84d187ce460$var$FormController() {
    return {
        // Public properties.
        isSubmitting: false,
        // Public methods.
        handleSubmit: handleSubmit
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I manage the form submission.
	*/ function handleSubmit(event) {
        if (this.isSubmitting || !confirm("Are you sure you want to merge these two exercises?")) {
            event.preventDefault();
            return;
        }
        this.isSubmitting = true;
    }
}


var $203623caaaeb8db8$exports = {};
// Import module styles.



var $d2b251e959209bed$exports = {};
// Import module styles.



var $987283642f0b6e6e$exports = {};
// Import module styles.



var $9316b982fef5b540$exports = {};
// Import module styles.



var $1b2ab74102a737be$exports = {};
// Import module styles.

// Define controllers.
window.crpu1p = {
    FormController: $1b2ab74102a737be$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $1b2ab74102a737be$var$FormController() {
    // Auto-save the form as people type.
    var form = document.querySelector(".perform-exercise");
    var submitTimer = null;
    form.addEventListener("input", prepareForAutoSubmit);
    form.addEventListener("submit", handleSubmit);
    // I handle the submit event on the form.
    function handleSubmit() {
        // If the user is submitting the form, we want to cancel any pending
        // background submit timer that is in-flight.
        clearTimeout(submitTimer);
    }
    // I setup the background timer for auto-save.
    function prepareForAutoSubmit() {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(autoSubmitForm, 750);
    }
    // I POST the form to the server in the background.
    function autoSubmitForm() {
        var formAction = form.getAttribute("action");
        var formMethod = form.getAttribute("method");
        var formData = new FormData(form);
        fetch(formAction, {
            method: formMethod,
            body: formData
        }).catch((error)=>{
            // NOTE: This only represents transport errors, not HTTP error
            // responses from the server. We don't care about server
            // responses since we're only optimistically saving the form.
            console.group("Auto submit error");
            console.error(error);
            console.groupEnd();
        });
    }
}


var $f8a9f3a0459c3990$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.mcpkrx = {
    FormController: $f8a9f3a0459c3990$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $f8a9f3a0459c3990$var$FormController() {
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    function handleSearchInput() {
        var keywords = (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets)target.node.hidden = !(0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords);
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
}


var $0dd4439b0ac12bf0$exports = {};
// Import module styles.



var $1fef17525aaecfa2$exports = {};
// Import module styles.

// Define controllers.
window.yqcw6t = {
    FormController: $1fef17525aaecfa2$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $1fef17525aaecfa2$var$FormController() {
    (function setupCompareToSets() {
        var form = document.querySelector("form");
        var compareToInstance = form.querySelector("input[name='compareToInstance']");
        for (var node of document.querySelectorAll("button[name='compareSets']"))node.addEventListener("click", handleCompareSetsClick);
        function handleCompareSetsClick(event) {
            var target = event.currentTarget;
            compareToInstance.value = target.value;
            form.requestSubmit();
        }
    })();
    var weightHelpNode = document.querySelector(".weight-help");
    var totalWeightNode = weightHelpNode.querySelector("input[name='totalWeight']");
    var equipmentWeightNode = weightHelpNode.querySelector("input[name='equipmentWeight']");
    var weightIncrementButtons = weightHelpNode.querySelectorAll(".weight-help-incr button");
    var isEquipmentSplitLoadedNode = weightHelpNode.querySelector("input[name='isEquipmentSplitLoaded']");
    var closeWeightHelpButtonNode = weightHelpNode.querySelector(".close-weight-help .close-only");
    var closeAndApplyWeightHelpButtonNode = weightHelpNode.querySelector(".close-weight-help .close-and-apply");
    var lastActiveWeightNode = null;
    var leftWeightsNode = weightHelpNode.querySelector(".weight-illustration__left");
    var rightWeightsNode = weightHelpNode.querySelector(".weight-illustration__right");
    var plateListNode = weightHelpNode.querySelector(".plate-list");
    var plateList45Node = plateListNode.querySelector(".plate-list__count.lb-45");
    var plateList25Node = plateListNode.querySelector(".plate-list__count.lb-25");
    var plateList10Node = plateListNode.querySelector(".plate-list__count.lb-10");
    var plateList5Node = plateListNode.querySelector(".plate-list__count.lb-5");
    var plateList2_5Node = plateListNode.querySelector(".plate-list__count.lb-2-5");
    var overflowWeightNote = weightHelpNode.querySelector(".overflow-weight-note");
    var overflowWeightNoteRemaineder = weightHelpNode.querySelector(".overflow-weight-note__remainder");
    var maxHelpNode = document.querySelector(".max-help");
    var maxHelpChoiceElement = document.querySelector("input[name='max-help__choice']");
    var maxHelpCloseButton = document.querySelector(".max-help__close");
    var maxHelperDebounceTimer;
    closeWeightHelpButtonNode.addEventListener("click", closeWeightHelperAsModal);
    closeAndApplyWeightHelpButtonNode.addEventListener("click", closeWeightHelperAsModal);
    totalWeightNode.addEventListener("input", updateWeightHelp);
    equipmentWeightNode.addEventListener("input", updateWeightHelp);
    isEquipmentSplitLoadedNode.addEventListener("input", updateWeightHelp);
    maxHelpCloseButton.addEventListener("click", closeMaxHelper);
    // Bind to the weight inputs and update as they are updated.
    for (var inputNode of document.querySelectorAll(".set__input[name='weight']")){
        inputNode.addEventListener("input", handleWeightInput);
        inputNode.addEventListener("input", handleMaxesInput.bind(null, "weight", true)); //handles max calculations
        inputNode.addEventListener("focus", handleWeightInput);
        inputNode.addEventListener("focus", handleWeightFocus);
        inputNode.addEventListener("input", handleChartingUpdates);
    }
    for (var inputNode of document.querySelectorAll(".set__input[name='reps']")){
        inputNode.addEventListener("input", handleMaxesInput.bind(null, "reps", true));
        inputNode.addEventListener("input", handleChartingUpdates);
    }
    // Bind the helper buttons.
    for (var openHelpNode of document.querySelectorAll(".set__help"))openHelpNode.addEventListener("click", openWeightHelperAsModal);
    // Bind to the incrementer buttons.
    for (var incrementNode of weightIncrementButtons)incrementNode.addEventListener("click", incrementWeightHelper);
    function openWeightHelperAsModal(event) {
        var parentElement = event.currentTarget.parentElement;
        var weightNode = parentElement.querySelector(".set__weight");
        var overlayNode = parentElement.querySelector(".set__overlay");
        lastActiveWeightNode = weightNode;
        // If there is no weight entered into the input, use any previous weight
        // that might be available.
        totalWeightNode.value = weightNode.value.trim() || overlayNode.textContent.trim() || "";
        updateWeightHelp();
        weightHelpNode.classList.add("modal");
        weightHelpNode.scrollTop = 0;
    // totalWeightNode.focus();
    }
    function closeMaxHelper(event) {
        maxHelpNode.classList.add('hidden');
    }
    function closeWeightHelperAsModal(event) {
        var button = event.currentTarget;
        weightHelpNode.classList.remove("modal");
        if (lastActiveWeightNode) {
            if (button === closeAndApplyWeightHelpButtonNode || !lastActiveWeightNode.value) lastActiveWeightNode.value = totalWeightNode.value;
            lastActiveWeightNode.focus();
        }
    }
    function handleWeightFocus(event) {
        for (var node of document.querySelectorAll(".set"))node.classList.remove("active");
        event.currentTarget.parentElement.parentElement.classList.add("active");
    }
    function incrementWeightHelper(event) {
        var increment = +event.currentTarget.dataset.increment;
        var currentWeight = +totalWeightNode.value || 0;
        var nextWeight = currentWeight + increment;
        totalWeightNode.value = nextWeight;
        updateWeightHelp();
    }
    function handleMaxesInput(inputType, clearTimer, event) {
        //check if maxHelpChoiceElement is checked. if not, return
        if (!maxHelpChoiceElement || !maxHelpChoiceElement.checked) return;
        if (clearTimer) {
            clearTimeout(maxHelperDebounceTimer);
            const target = event.currentTarget;
            maxHelperDebounceTimer = setTimeout(function() {
                handleMaxesInput(inputType, false, {
                    currentTarget: target
                }); // Call the function after a delay
            }, 500); // Adjust the delay (in milliseconds) as needed	
            return;
        }
        let inputValue = event.currentTarget.value || -1;
        let repsNode = null;
        let weightNode = null;
        let repsValue = -1;
        let weightValue = -1;
        var parentElement = event.currentTarget.closest('.set');
        switch(inputType){
            case 'weight':
                repsNode = parentElement.querySelector(".set__input[name='reps']");
                weightNode = event.currentTarget;
                weightValue = parseInt(inputValue);
                repsValue = parseInt(repsNode.value || -1);
                break;
            case 'reps':
                weightNode = parentElement.querySelector(".set__input[name='weight']");
                repsNode = event.currentTarget;
                weightValue = parseInt(weightNode.value || -1);
                repsValue = parseInt(inputValue);
                break;
        }
        if (repsValue > 0 && weightValue < 0) ;
        else if (weightValue > 0 && repsValue < 0) ;
        else return;
        // var formData = new FormData( form );
        var fetchPath = '?event=member.exerciseMax';
        var exerciseID = maxHelpNode.dataset.exerciseId;
        var format = 'json';
        fetch(`${fetchPath}&exercise=${exerciseID}&reps=${repsValue}&weight=${weightValue}&format=${format}`).then((response)=>{
            if (!response.ok) console.error(new Error('Network response was not ok'));
            return response.json();
        }).then((data)=>{
            //just put the json data into the maxHelpNode. we can get cuter later
            const inputElement = event.currentTarget;
            const rect = inputElement.getBoundingClientRect();
            //find children of maxHelpNode with class of max-help-child and set display to hidden
            const children = maxHelpNode.querySelectorAll('.max-help-child');
            children.forEach((child)=>{
                child.classList.add('hidden');
            });
            if (data.length > 0) {
                data = data[0];
                const reps = data.set.reps;
                const weight = data.set.weight;
                const date = data.set.date;
                const label = data.label;
                const childNode = maxHelpNode.querySelector(`.${label}`);
                //set the data values inthe the childNode elements
                if (childNode.querySelector('.rep-max')) {
                    childNode.querySelector('.rep-max').innerHTML = reps ?? '';
                    if (!reps || reps <= 0) childNode.querySelector('.max-achievement-date-container').classList.add('hidden');
                    else childNode.querySelector('.max-achievement-date-container').classList.remove('hidden');
                }
                if (childNode.querySelector('.weight-max')) {
                    childNode.querySelector('.weight-max').innerHTML = weight ?? '';
                    if (!weight || weight <= 0) childNode.querySelector('.max-achievement-date-container').classList.add('hidden');
                    else childNode.querySelector('.max-achievement-date-container').classList.remove('hidden');
                }
                if (childNode.querySelector('.weight-entered')) childNode.querySelector('.weight-entered').innerHTML = weightValue ?? '';
                if (childNode.querySelector('.reps-entered')) childNode.querySelector('.reps-entered').innerHTML = repsValue ?? '';
                if (childNode.querySelector('.max-achievement-date')) childNode.querySelector('.max-achievement-date').innerHTML = date ?? '';
                // remove the hidden class from the appropriate child where label = the class name
                childNode.classList.remove('hidden');
            }
            //place the node directly beneath the input. It is already absolutely positioned. need to set the top. left position will depend on the screen size and handled in the css
            maxHelpNode.style.top = rect.top + window.scrollY + inputElement.offsetHeight + 5 + 'px';
            //remove the hidden class from the node
            maxHelpNode.classList.remove('hidden');
            //set a timeout to re-hide the node after a few seconds
            setTimeout(function() {
                closeMaxHelper();
            }, 7000);
        }).catch((error)=>{
            // NOTE: This only represents transport errors, not HTTP error
            // responses from the server. We don't care about server
            // responses since we're only optimistically saving the form.
            console.group("Max Calculation Error");
            console.error(error);
            console.groupEnd();
        });
    }
    function handleWeightInput(event) {
        lastActiveWeightNode = event.currentTarget;
        totalWeightNode.value = event.currentTarget.value || "";
        updateWeightHelp();
    }
    function updateWeightHelp() {
        var totalWeight = Number(totalWeightNode.value) || 0;
        var equipmentWeight = Number(equipmentWeightNode.value) || 0;
        var loadedWeight = Math.max(totalWeight - equipmentWeight, 0);
        var isTwoSided = isEquipmentSplitLoadedNode.checked;
        var weights = {
            "45": 0,
            "25": 0,
            "10": 0,
            "5": 0,
            "2.5": 0
        };
        var remainingWeight = isTwoSided ? loadedWeight / 2 : loadedWeight;
        weights["45"] = Math.floor(remainingWeight / 45);
        remainingWeight -= weights["45"] * 45;
        weights["25"] = Math.floor(remainingWeight / 25);
        remainingWeight -= weights["25"] * 25;
        weights["10"] = Math.floor(remainingWeight / 10);
        remainingWeight -= weights["10"] * 10;
        weights["5"] = Math.floor(remainingWeight / 5);
        remainingWeight -= weights["5"] * 5;
        weights["2.5"] = Math.floor(remainingWeight / 2.5);
        remainingWeight -= weights["2.5"] * 2.5;
        // Clear both sides.
        leftWeightsNode.replaceChildren();
        rightWeightsNode.replaceChildren();
        if (remainingWeight) {
            overflowWeightNote.classList.add("active");
            overflowWeightNoteRemaineder.textContent = isTwoSided ? remainingWeight * 2 : remainingWeight;
        } else overflowWeightNote.classList.remove("active");
        // We only want to render the illustration if the number of places is
        // reasonably small. Otherwise, we might crash the browser.
        if (loadedWeight <= 1000) {
            for(var i = 0; i < weights["45"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-45");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["25"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-25");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["10"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-10");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["5"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-5");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
            for(var i = 0; i < weights["2.5"]; i++){
                var plate = document.createElement("span");
                plate.classList.add("weight-illustration__plate", "lb-2-5");
                leftWeightsNode.prepend(plate.cloneNode());
                if (isTwoSided) rightWeightsNode.append(plate.cloneNode());
            }
        }
        // Update plate list.
        if (weights["45"]) {
            plateList45Node.textContent = weights["45"];
            plateList45Node.parentNode.classList.remove("empty");
        } else {
            plateList45Node.textContent = "";
            plateList45Node.parentNode.classList.add("empty");
        }
        if (weights["25"]) {
            plateList25Node.textContent = weights["25"];
            plateList25Node.parentNode.classList.remove("empty");
        } else {
            plateList25Node.textContent = "";
            plateList25Node.parentNode.classList.add("empty");
        }
        if (weights["10"]) {
            plateList10Node.textContent = weights["10"];
            plateList10Node.parentNode.classList.remove("empty");
        } else {
            plateList10Node.textContent = "";
            plateList10Node.parentNode.classList.add("empty");
        }
        if (weights["5"]) {
            plateList5Node.textContent = weights["5"];
            plateList5Node.parentNode.classList.remove("empty");
        } else {
            plateList5Node.textContent = "";
            plateList5Node.parentNode.classList.add("empty");
        }
        if (weights["2.5"]) {
            plateList2_5Node.textContent = weights["2.5"];
            plateList2_5Node.parentNode.classList.remove("empty");
        } else {
            plateList2_5Node.textContent = "";
            plateList2_5Node.parentNode.classList.add("empty");
        }
    }
    (function setupInputmodeToggling() {
        var toggleToText = document.querySelector(".keyboard-toggle__control.text");
        var toggleToNumeric = document.querySelector(".keyboard-toggle__control.numeric");
        var tempInput = document.querySelector(".keyboard-toggle__temp");
        var setInputs = document.querySelectorAll(".set__input");
        var lastActiveInput = null;
        toggleToText.addEventListener("input", handleToggleClick);
        toggleToNumeric.addEventListener("input", handleToggleClick);
        for (var input of setInputs)input.addEventListener("focus", handleInputFocus);
        updateInputs();
        function handleInputFocus(event) {
            lastActiveInput = event.currentTarget;
        }
        function handleToggleClick(event) {
            updateInputs();
            if (lastActiveInput) {
                tempInput.focus();
                requestAnimationFrame(()=>lastActiveInput.focus());
            }
        }
        function updateInputs() {
            if (toggleToText.checked) {
                var inputMode = "text";
                var pattern = ".*";
            } else {
                var inputMode = "decimal";
                var pattern = "[0-9.]*";
            }
            for (var input of setInputs){
                input.inputMode = inputMode;
                input.pattern = pattern;
            }
        }
    })();
    for (var node of document.querySelectorAll(".set__input"))if (node.value === "") {
        node.focus();
        node.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        break;
    }
    (function setupPrevNotesCycling() {
        var notes = document.querySelectorAll(".prev-notes__info");
        var nextNote = document.querySelector(".prev-notes__nav--next");
        var prevNote = document.querySelector(".prev-notes__nav--prev");
        var activeIndex = 0;
        var maxIndex = notes.length - 1;
        if (!nextNote || !prevNote) return;
        nextNote.addEventListener("click", gotoNextNote);
        prevNote.addEventListener("click", gotoPrevNote);
        function gotoNextNote(event) {
            clearActive();
            activeIndex = activeIndex > 0 ? activeIndex - 1 : maxIndex;
            applyActive();
        }
        function gotoPrevNote(event) {
            clearActive();
            activeIndex = activeIndex < maxIndex ? activeIndex + 1 : 0;
            applyActive();
        }
        function clearActive() {
            notes[activeIndex].classList.remove("active");
        }
        function applyActive() {
            notes[activeIndex].classList.add("active");
        }
    })();
    (function setupBackgroundSave() {
        var form = document.querySelector(".perform-exercise");
        var submitTimer = null;
        form.addEventListener("input", prepareForAutoSubmit);
        form.addEventListener("submit", handleSubmit);
        // I handle the submit event on the form.
        function handleSubmit() {
            // If the user is submitting the form, we want to cancel any pending
            // background submit timer that is in-flight.
            clearTimeout(submitTimer);
        }
        // I setup the background timer for auto-save.
        function prepareForAutoSubmit() {
            clearTimeout(submitTimer);
            submitTimer = setTimeout(autoSubmitForm, 750);
        }
        // I POST the form to the server in the background.
        function autoSubmitForm() {
            var formAction = form.getAttribute("action");
            var formMethod = form.getAttribute("method");
            var formData = new FormData(form);
            fetch(formAction, {
                method: formMethod,
                body: formData
            }).catch((error)=>{
                // NOTE: This only represents transport errors, not HTTP error
                // responses from the server. We don't care about server
                // responses since we're only optimistically saving the form.
                console.group("Auto submit error");
                console.error(error);
                console.groupEnd();
            });
        }
    })();
    class CircularProgressBar {
        constructor(elementId){
            this.el = document.getElementById(elementId);
            if (!this.el) //element was not found
            return;
            // Initialize options from the element's data attributes
            this.options = {
                current: parseFloat(this.el.getAttribute('data-current')) || 0,
                intensityMultiplier: parseFloat(this.el.getAttribute('data-intensity-multiplier')) || 0,
                max: parseFloat(this.el.getAttribute('data-max')) || 100,
                size: parseInt(this.el.getAttribute('data-size')) || 150,
                lineWidth: parseInt(this.el.getAttribute('data-line')) || 10,
                rotate: parseInt(this.el.getAttribute('data-rotate')) || 0
            };
            // Calculate initial percentage
            this.options.percent = this.options.current / this.options.max * 100;
            // Create canvas and span elements
            this.canvas = document.createElement('canvas');
            this.span = document.createElement('span');
            this.el.style.width = `${this.options.size}px`;
            this.el.style.height = `${this.options.size}px`;
            // Append elements to the parent container
            this.el.appendChild(this.span);
            this.el.appendChild(this.canvas);
            // Setup canvas context
            if (typeof G_vmlCanvasManager !== 'undefined') G_vmlCanvasManager.initElement(this.canvas);
            this.ctx = this.canvas.getContext('2d');
            this.canvas.width = this.canvas.height = this.options.size;
            // Translate and rotate context
            this.ctx.translate(this.options.size / 2, this.options.size / 2);
            this.ctx.rotate((-0.5 + this.options.rotate / 180) * Math.PI);
            // Set radius
            this.radius = (this.options.size - this.options.lineWidth) / 2;
            // Initial draw
            this.draw();
        }
        draw() {
            if (!this.el) return;
            const drawCircle = (color, lineWidth, percent)=>{
                percent = Math.min(Math.max(0, percent), 1); // Clamp between 0 and 1
                this.ctx.beginPath();
                this.ctx.arc(0, 0, this.radius, 0, Math.PI * 2 * percent, false);
                this.ctx.strokeStyle = color;
                this.ctx.lineCap = 'round'; // Line cap: round
                this.ctx.lineWidth = lineWidth;
                this.ctx.stroke();
            };
            // Clear the canvas
            this.ctx.clearRect(-this.options.size / 2, -this.options.size / 2, this.options.size, this.options.size);
            // Draw the background and progress
            drawCircle('#efefef', this.options.lineWidth, 1); // Background
            drawCircle('#4caf50', this.options.lineWidth, this.options.percent / 100); // Progress
            // Update text in the center
            this.span.textContent = `${Math.round(this.options.percent)}%`;
        }
        update(current) {
            if (!this.el) return;
            this.options.current = current;
            if (this.options.max == 0) this.options.percent = 0;
            else this.options.percent = current / this.options.max * 100;
            this.draw();
        }
        getIntensityMultiplierRatio(set1RM) {
            if (!this.el) return;
            if (this.options.intensityMultiplier === 0 || isNaN(set1RM) || set1RM === 0) return 1;
            return set1RM / this.options.intensityMultiplier;
        }
    }
    // Initialize a circular progress bar
    const volumeProgressBar = new CircularProgressBar('volume-graph');
    function handleChartingUpdates() {
        //need to hunt down all of the sets and reps and create a volume
        let totalVolume = 0;
        // Get all the sets
        const sets = document.querySelectorAll('.set');
        // Iterate over each set
        sets.forEach((set)=>{
            const weightInput = set.querySelector('.set__weight');
            const repsInput = set.querySelector('.set__reps');
            // Parse weight and reps values
            const weight = parseFloat(weightInput.value) || 0;
            const reps = parseInt(repsInput.value, 10) || 0;
            const estimated1RM = estimate1RM(weight, reps);
            // Calculate the volume for this set
            totalVolume += weight * reps * volumeProgressBar.getIntensityMultiplierRatio(estimated1RM);
        });
        // Update the progress bar
        volumeProgressBar.update(totalVolume);
    }
    handleChartingUpdates();
    /**
	 * Estimate a 1RM based on a given weight and rep count using the Brzycki Equation.
	 * Ensures that weight and reps are numeric values.
	 * This also exists in client.main.lib.ExerciseMax.cfc, but we need to use it for the real-time charting as well
	 *
	 * @param {number|string} weight - The weight used for the calculation.
	 * @param {number|string} reps - The number of reps used for the calculation.
	 * @returns {number} The estimated 1RM, or 0 if the calculation is invalid.
	*/ function estimate1RM(weight, reps) {
        // Ensure weight and reps are numeric
        weight = isNaN(weight) ? 0 : parseFloat(weight);
        reps = isNaN(reps) ? 0 : parseInt(reps, 10);
        // Using the Brzycki Equation
        const denominator = 1.0278 - 0.0278 * reps;
        if (denominator === 0) return 0;
        return weight / denominator;
    }
}


var $7f63e51ab3af258d$exports = {};
// Import module styles.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Define controllers.
window.mhm2qa = {
    FormController: $7f63e51ab3af258d$var$FormController
};
// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function $7f63e51ab3af258d$var$FormController() {
    var selectRecentLink = document.querySelector(".select-recent");
    var searchInput = document.querySelector(".search-bar__input");
    var searchClear = document.querySelector(".search-bar__button");
    var movementInputs = document.querySelectorAll("input[name='movementKind']");
    var movementKind = null;
    var searchTargets = Array.from(document.querySelectorAll(".search-target")).map((node)=>{
        return {
            node: node,
            keywords: (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizePipeText(node.dataset.keywords)
        };
    });
    searchInput.addEventListener("input", handleSearchInput);
    searchClear.addEventListener("click", handleSearchClear);
    for (var node of movementInputs)node.addEventListener("input", handleMovementInput);
    setMovementKind();
    handleSearchInput();
    function setMovementKind() {
        movementKind = null;
        for (var node of movementInputs)if (node.checked) movementKind = node.value;
    }
    function handleMovementInput(event) {
        setMovementKind();
        handleSearchInput();
        updateSelectRecent();
    }
    function handleSearchInput() {
        var keywords = (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).normalizeText(searchInput.value);
        for (var target of searchTargets){
            var isMatch = (0, $5874c6f4fbf644a5$export$2e2bcd8739ae039).isFuzzyMatchMulti(target.keywords, keywords) && isMovementMatch(target);
            target.node.hidden = !isMatch;
        }
    }
    function handleSearchClear() {
        searchInput.value = "";
        handleSearchInput();
    }
    function isMovementMatch(target) {
        return movementKind === "all" || movementKind === "push" && target.node.dataset.isPush === "yes" || movementKind === "pull" && target.node.dataset.isPull === "yes" || movementKind === "legs" && target.node.dataset.isLegs === "yes";
    }
    function updateSelectRecent() {
        var url = new window.URL(selectRecentLink.href);
        url.searchParams.set("movementKind", movementKind);
        selectRecentLink.href = url.toString();
    }
}


var $1eb80d1fa773d568$exports = {};
// Define controllers.
window.nujwvf = {
    FormController: $1eb80d1fa773d568$var$FormController
};
// Todo: This isn't really the way Alpine.js components are supposed to be built - I'm
// just trying to get all the script tags out of the views.
function $1eb80d1fa773d568$var$FormController() {
    var host = this.$el;
    var movementKind = null;
    var selectAllLink = document.querySelector(".select-all");
    var checkboxes = host.querySelectorAll("input[name='movementKind']");
    var listItems = host.querySelectorAll("li[data-is-push], li[data-is-pull], li[data-is-legs]");
    for (var node of checkboxes)node.addEventListener("input", handleCheckbox);
    // Handle any initial filtering.
    setMovementKind();
    updateListFiltering();
    function setMovementKind() {
        movementKind = null;
        for (var node of checkboxes)if (node.checked) movementKind = node.value;
    }
    function handleCheckbox(event) {
        setMovementKind();
        updateListFiltering();
        updateSelectAll();
    }
    function updateListFiltering() {
        for (var node of listItems){
            var isMatch = movementKind === "all" || movementKind === "push" && node.dataset.isPush === "yes" || movementKind === "pull" && node.dataset.isPull === "yes" || movementKind === "legs" && node.dataset.isLegs === "yes";
            node.hidden = !isMatch;
        }
    }
    function updateSelectAll() {
        var url = new window.URL(selectAllLink.href);
        url.searchParams.set("movementKind", movementKind);
        selectAllLink.href = url.toString();
    }
}


$20647d6030f59c56$exports = {
    "common": {
        "tags": {
            "errorMessage.view": $b52e6f1093ca412c$exports,
            "flashMessage.view": $c140a07e1815a238$exports,
            "localDebugging.view": $65ee7748ed1fcee1$exports
        }
    },
    "auth": {
        "verifyLogin": {
            "verifyLogin.view": $82936e26418b3eb9$exports
        }
    },
    "member": {
        "common": {
            "layout.view": $f0f46394c28034e1$exports
        },
        "cardioExercises": {
            "catalogList": {
                "catalogList.view": $b5f661c94b864ab5$exports
            },
            "list": {
                "list.view": $5d1d409dc9148d62$exports
            }
        },
        "contributors": {
            "overview": {
                "overview.view": $e9cf01e1174e3df2$exports
            }
        },
        "home": {
            "welcome": {
                "welcome.view": $9c580889636c49f4$exports
            }
        },
        "gratitudeJournal": {
            "create": {
                "create.view": $a8ffad4a264ddcd3$exports
            }
        },
        "jointBalance": {
            "overview": {
                "overview.view": $b35af2c19aa8f428$exports
            }
        },
        "repRanges": {
            "overview": {
                "overview.view": $d0655391e575531c$exports
            }
        },
        "resistanceExercises": {
            "catalogList": {
                "catalogList.view": $a5360da36d2ffc34$exports
            },
            "exerciseList": {
                "exerciseList.view": $11a23512afed2076$exports
            },
            "view": {
                "view": $4b0dca4e96bf7b58$exports
            },
            "merge": {
                "merge.view": $644bb84d187ce460$exports
            },
            "instances": {
                "backfill": {
                    "backfill.view": $203623caaaeb8db8$exports
                },
                "edit": {
                    "edit.view": $d2b251e959209bed$exports
                },
                "view": {
                    "view.view": $987283642f0b6e6e$exports
                }
            }
        },
        "workout": {
            "start": {
                "start.view": $9316b982fef5b540$exports
            },
            "cardio": {
                "performExercise": {
                    "performExercise.view": $1b2ab74102a737be$exports
                },
                "selectExercise": {
                    "selectExercise.view": $f8a9f3a0459c3990$exports
                },
                "selectRecentExercise": {
                    "selectRecentExercise.view": $0dd4439b0ac12bf0$exports
                }
            },
            "resistance": {
                "performExercise": {
                    "performExercise.view": $1fef17525aaecfa2$exports
                },
                "selectExercise": {
                    "selectExercise.view": $7f63e51ab3af258d$exports
                },
                "selectRecentExercise": {
                    "selectRecentExercise.view": $1eb80d1fa773d568$exports
                }
            }
        }
    }
};


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
window.Alpine = (0, $4180c5bc1a83c67d$export$2e2bcd8739ae039);
(0, $4180c5bc1a83c67d$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=main.764a9f5a.js.map
